// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4eb2dd9","239":"359fd99c","455":"e7e876cd"}[chunkId] + ".chunk.js";
};